export const CREATE_CHANGE_ORDER = 'createChangeOrder';
export const FETCH_CHANGE_ORDER_BY_ID = 'fetchChangeOrderById';
export const FETCH_PROJECT_CHANGE_ORDERS = 'fetchProjectChangeOrders';
export const UPDATE_CHANGE_ORDER_BY_ID = 'updateChangeOrderById';
export const DELETE_CHANGE_ORDER_BY_ID = 'deleteChangeOrderById';
